export const SHARE_BUTTON_NAMES = {
    FACEBOOK: 'facebook',
    TWITTER: 'twitter',
    LINKEDIN: 'linkedin',
};
export const DOWNLOAD_TICKETS_BUTTON_NAMES = {
    PDF: 'download_pdf',
    APPLE_WALLET: 'add_to_apple_wallet',
};
export const BI_ORIGINS = {
    MEMBERS_AREA: 'members area',
    WIDGET: 'widget',
    EVENT_DETAILS: 'event details',
    THANK_YOU_PAGE: 'thank you page',
    MAP: 'map',
    SEATINGS_MODAL_TICKET_LIST: 'ticket_list',
    SEATINGS_MODAL_BASKET: 'basket',
};
export const BI_ENDPOINTS = {
    EVENTS_UOU: 'events-uou',
    EVENTS_USERS: 'events-users',
};
/** @deprecated use BI_MODAL_BUTTONS */
export const MODAL_BUTTONS = {
    CONTINUE: 'continue',
    CANCEL: 'cancel',
    X: 'x',
    SAVE_LEAVE: 'save_leave',
    DISCONNECT: 'disconnect',
    TURN_OFF: 'turn_off',
    SHOW_PRICES: 'show_prices',
    HIDE_PRICES: 'hide_prices',
    ZOOM_IN: 'zoom_in',
    ZOOM_OUT: 'zoom_out',
};
export var BI_MODAL_BUTTONS;
(function (BI_MODAL_BUTTONS) {
    BI_MODAL_BUTTONS["CONTINUE"] = "continue";
    BI_MODAL_BUTTONS["CANCEL"] = "cancel";
    BI_MODAL_BUTTONS["X"] = "x";
    BI_MODAL_BUTTONS["SAVE_LEAVE"] = "save_leave";
    BI_MODAL_BUTTONS["DISCONNECT"] = "disconnect";
    BI_MODAL_BUTTONS["TURN_OFF"] = "turn_off";
    BI_MODAL_BUTTONS["SHOW_PRICES"] = "show_prices";
    BI_MODAL_BUTTONS["HIDE_PRICES"] = "hide_prices";
    BI_MODAL_BUTTONS["ZOOM_IN"] = "zoom_in";
    BI_MODAL_BUTTONS["ZOOM_OUT"] = "zoom_out";
})(BI_MODAL_BUTTONS || (BI_MODAL_BUTTONS = {}));
export const CUSTOM_DATES_BANNER_NAMES = {
    TICKETS: 'tickets',
    REGISTRATION_SETTINGS: 'registration_settings',
    PAST_EVENT: 'past_event',
};
export const WARNING_BANNER_NAMES = {
    NO_TICKETS: 'no_tickets',
    TICKET_MAPPING: 'ticket_mapping',
};
export var BI_ENTITY_TYPE;
(function (BI_ENTITY_TYPE) {
    BI_ENTITY_TYPE["ticketDefinition"] = "ticketDefinition";
    BI_ENTITY_TYPE["policy"] = "policy";
    BI_ENTITY_TYPE["rsvp"] = "rsvp";
    BI_ENTITY_TYPE["ticket"] = "ticket";
    BI_ENTITY_TYPE["order"] = "order";
    BI_ENTITY_TYPE["category"] = "category";
    BI_ENTITY_TYPE["coupon"] = "coupon";
})(BI_ENTITY_TYPE || (BI_ENTITY_TYPE = {}));
//# sourceMappingURL=bi.js.map